import { render, staticRenderFns } from "./dropdown-quick-actions.html?vue&type=template&id=72bb2abe&scoped=true&external"
import script from "./dropdown-quick-actions.js?vue&type=script&lang=js&external"
export * from "./dropdown-quick-actions.js?vue&type=script&lang=js&external"
import style0 from "./dropdown-quick-actions.scss?vue&type=style&index=0&id=72bb2abe&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bb2abe",
  null
  
)

export default component.exports